exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-border{border:1px dashed red;border-bottom:0;border-right:0}", ""]);

// exports
